module.exports = __webpack_public_path__ + "static/img/partner_XII.ec746cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_XII.png
// module id = NleD
// module chunks = 9